// Fixes for the product image gallery and zoom/lightbox modal.
//
// 1) Main gallery prev/next arrows: Dawn's built-in slider-component JS
//    scrolls the gallery's <ul> horizontally, but in "thumbnail" gallery
//    layouts the main image list isn't a scrollable slider on desktop —
//    images are switched by toggling a CSS class via thumbnail clicks
//    instead. We simulate a click on the correct thumbnail instead, which
//    reuses Dawn's own (working) switching logic.
//
// 2) Zoom modal open-to-correct-image: Dawn relies on native vertical
//    anchor-scrolling to bring the right image into view, which doesn't
//    work once the modal pages horizontally. We detect which slide was
//    clicked (via ModalDialog's own `openedBy` reference) and set
//    scrollLeft directly.
//
// 3) Zoom modal prev/next arrows: Dawn's ModalDialog closes the whole
//    modal on ANY pointerup inside it (except on video/3D elements) — so
//    clicking our nav arrows was being intercepted and closing the modal
//    before it could page. We stop that pointerup from reaching Dawn's
//    listener specifically for our nav buttons, then handle the actual
//    paging ourselves on click.
//
// 4) Fixed-size gallery frame: Dawn sets TWO custom properties inline on
//    .product-media-container per photo — "--ratio" and a second,
//    separate "--preview-ratio" — and re-applies both (with !important)
//    every time the active slide changes. Locking only "--ratio" wasn't
//    enough because the actual rendered height turned out to be driven by
//    "--preview-ratio" instead. This locks BOTH to a constant square
//    value, permanently, so the frame truly never resizes.

document.addEventListener(
  'pointerup',
  function (event) {
    if (event.target.closest('.product-media-modal__nav')) {
      event.stopPropagation();
    }
  },
  true
);

document.addEventListener('click', function (event) {
  // --- Main gallery prev/next arrows ---
  var galleryBtn = event.target.closest('.product-gallery-slider-buttons .slider-button');
  if (galleryBtn) {
    var mediaGallery = galleryBtn.closest('media-gallery');
    var thumbsWrap = mediaGallery && mediaGallery.querySelector('[id^="GalleryThumbnails-"]');
    if (thumbsWrap) {
      var thumbButtons = Array.prototype.slice.call(
        thumbsWrap.querySelectorAll('li[data-target] button')
      );
      if (thumbButtons.length > 1) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var currentIndex = thumbButtons.findIndex(function (b) {
          return b.getAttribute('aria-current') === 'true';
        });
        if (currentIndex === -1) currentIndex = 0;
        var direction = galleryBtn.classList.contains('slider-button--next') ? 1 : -1;
        var nextIndex = (currentIndex + direction + thumbButtons.length) % thumbButtons.length;
        thumbButtons[nextIndex].click();
      }
    }
    return;
  }

  // --- Zoom modal prev/next arrows ---
  var modalNavBtn = event.target.closest('.product-media-modal__nav');
  if (modalNavBtn) {
    event.preventDefault();
    event.stopPropagation();
    var modal = modalNavBtn.closest('.product-media-modal');
    var content = modal && modal.querySelector('.product-media-modal__content');
    if (content) {
      var dir = modalNavBtn.classList.contains('product-media-modal__nav--next') ? 1 : -1;
      var target = content.scrollLeft + dir * content.clientWidth;
      content.scrollTo({ left: target, behavior: 'smooth' });
    }
  }
});

// --- Open the zoom modal on the image that was actually clicked ---
document.querySelectorAll('.product-media-modal').forEach(function (modal) {
  var content = modal.querySelector('.product-media-modal__content');
  if (!content) return;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName !== 'open' || !modal.hasAttribute('open')) return;
      var opener = modal.openedBy;
      if (!opener) return;
      var slide = opener.closest('[data-media-id]');
      if (!slide) return;
      var mediaId = slide.getAttribute('data-media-id');
      var target = content.querySelector('[data-media-id="' + mediaId + '"]');
      if (target) {
        content.scrollLeft = target.offsetLeft;
      }
    });
  });
  observer.observe(modal, { attributes: true });
});

// --- Force a constant square gallery frame, permanently ---
(function () {
  var FIXED_RATIO = '1';

  function lockRatios(container) {
    if (container.style.getPropertyValue('--ratio') !== FIXED_RATIO) {
      container.style.setProperty('--ratio', FIXED_RATIO, 'important');
    }
    if (container.style.getPropertyValue('--preview-ratio') !== FIXED_RATIO) {
      container.style.setProperty('--preview-ratio', FIXED_RATIO, 'important');
    }
  }

  document.querySelectorAll('.product-media-container').forEach(function (container) {
    lockRatios(container);
    var observer = new MutationObserver(function () {
      lockRatios(container);
    });
    observer.observe(container, { attributes: true, attributeFilter: ['style'] });
  });
})();
